import { createTheme } from "@mantine/core";
import {
	type ColorScheme,
	type ColorTheme,
	canvasBgOf,
	PLAY_COLOR_TUPLES,
	parseColorScheme,
	parseColorTheme,
	THEME_TOKENS,
	themeSemantics,
} from "@play/shared";

export {
	type ColorScheme,
	type ColorTheme,
	canvasBgOf,
	parseColorScheme,
	parseColorTheme,
};

export const COLOR_THEME_OPTIONS: Array<{
	value: ColorTheme;
	labelKey: string;
}> = [
	{ value: "brand", labelKey: "staff.themeBrand" },
	{ value: "mist", labelKey: "staff.themeMist" },
	{ value: "summer", labelKey: "staff.themeSummer" },
	{ value: "winter", labelKey: "staff.themeWinter" },
	{ value: "earth", labelKey: "staff.themeEarth" },
	{ value: "sun", labelKey: "staff.themeSun" },
];

const THEME_STORAGE_KEY = "play-admin.color-theme";
const SCHEME_STORAGE_KEY = "play-admin.color-scheme";

export function readStoredColorTheme(): ColorTheme {
	if (typeof localStorage === "undefined") {
		return "brand";
	}
	return parseColorTheme(localStorage.getItem(THEME_STORAGE_KEY));
}

export function persistColorTheme(theme: ColorTheme): void {
	if (typeof localStorage === "undefined") {
		return;
	}
	localStorage.setItem(THEME_STORAGE_KEY, theme);
}

export function readStoredColorScheme(): ColorScheme {
	if (typeof localStorage === "undefined") {
		return "light";
	}
	return parseColorScheme(localStorage.getItem(SCHEME_STORAGE_KEY));
}

export function persistColorScheme(scheme: ColorScheme): void {
	if (typeof localStorage === "undefined") {
		return;
	}
	localStorage.setItem(SCHEME_STORAGE_KEY, scheme);
}

export function themeFor(theme: ColorTheme, scheme: ColorScheme = "light") {
	const tokens = THEME_TOKENS[theme];
	return createTheme({
		fontFamily: '"DM Sans", system-ui, sans-serif',
		primaryColor: tokens.primary,
		defaultRadius: "lg",
		colors: {
			playRed: [...PLAY_COLOR_TUPLES.playRed],
			playMist: [...PLAY_COLOR_TUPLES.playMist],
			playBlue: [...PLAY_COLOR_TUPLES.playBlue],
			playGreen: [...PLAY_COLOR_TUPLES.playGreen],
			playBrown: [...PLAY_COLOR_TUPLES.playBrown],
			playSun: [...PLAY_COLOR_TUPLES.playSun],
		},
		other: {
			canvasBg: tokens.canvasBg[scheme],
			...themeSemantics(scheme),
		},
		components: {
			Badge: {
				defaultProps: {
					tt: "none",
				},
				styles: {
					label: {
						overflow: "visible",
						textOverflow: "clip",
					},
				},
			},
			Modal: {
				defaultProps: {
					zIndex: 400,
				},
			},
			Popover: {
				defaultProps: {
					zIndex: 500,
				},
			},
		},
	});
}
